import About from "../components/sections/About";
import SideList from "../components/sections/SideList";
import Title from "../components/sections/Title";
import { about, basics, basicsAfter, basicsBefore, benefits, technique } from "../content/Chrono";

const color = "chrono";

function Chrono() {
  return (
    <main className="flex-grow-1">
      <Title title="kronobiológiai&nbsp;elemzés" color={color} />
      <About title="Kronobiológia" paragraphs={about} color={color} />
      <SideList
        id="basics"
        title="A kronobiológia alapjai"
        extraBefore={basicsBefore}
        listItems={basics}
        extraAfter={basicsAfter}
        color={color}
        reducedHeight={true}
      />
      <SideList
        id="practical-benefits"
        title="Gyakorlati haszna"
        listItems={benefits}
        alignRight={true}
        color={color}
      />

      <div
        className="px-4 py-3 my-4 text-center container-wide box-shadow"
        id="advice"
      >
        <div className="col-lg-10 mx-auto">
          <p className="mb-0">
            {technique}
          </p>
        </div>
      </div>
    </main>
  );
}

export default Chrono;
